import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "splide__arrows" }
const _hoisted_2 = { class: "splide__arrow splide__arrow--prev center-y absolute left-12 z-[5] rounded-full bg-white p-18 shadow-md" }
const _hoisted_3 = { class: "splide__arrow splide__arrow--next center-y absolute right-12 z-[5] rounded-full bg-white p-18 shadow-md" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_image = _resolveComponent("v-image")
  const _component_v_video = _resolveComponent("v-video")
  const _component_splide_slide = _resolveComponent("splide-slide")
  const _component_splide_track = _resolveComponent("splide-track")
  const _component_v_icon = _resolveComponent("v-icon")
  const _component_splide = _resolveComponent("splide")

  return (_openBlock(), _createBlock(_component_splide, {
    ref: "mainSlider",
    "has-track": false,
    class: "relative bg-black-100",
    options: {
      type: 'loop',
      arrows: $props.media.length > 1,
      pagination: true,
      mediaQuery: 'min',
      classes: {
        page: 'splide__pagination__page w-6 h-6 rounded-full bg-black-900',
      },
    }
  }, {
    default: _withCtx(() => [
      _createVNode(_component_splide_track, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.media, (media, i) => {
            return (_openBlock(), _createBlock(_component_splide_slide, {
              key: media.id
            }, {
              default: _withCtx(() => [
                (media.media_type === 'image')
                  ? (_openBlock(), _createBlock(_component_v_image, {
                      key: 0,
                      lazyloaded: i > 1,
                      source: media.src,
                      width: 600,
                      alt: media.alt,
                      class: "aspect-product-gallery w-full object-cover object-top"
                    }, null, 8, ["lazyloaded", "source", "alt"]))
                  : (media.media_type === 'video')
                    ? (_openBlock(), _createBlock(_component_v_video, {
                        key: 1,
                        autoplay: "",
                        source: media.sources[0].url,
                        "source-mobile": media.sources[0].url,
                        class: "aspect-product-gallery w-full object-cover object-top"
                      }, null, 8, ["source", "source-mobile"]))
                    : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", _hoisted_2, [
          _createVNode(_component_v_icon, {
            icon: "arrow-left",
            width: 12,
            height: 12
          })
        ]),
        _createElementVNode("button", _hoisted_3, [
          _createVNode(_component_v_icon, {
            icon: "arrow-left",
            width: 12,
            height: 12,
            flipped: ""
          })
        ])
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "h-full w-full" }, [
        _createElementVNode("ul", { class: "splide__pagination center-x absolute bottom-20 z-[5] gap-8" })
      ], -1))
    ]),
    _: 1,
    __: [0]
  }, 8, ["options"]))
}